<template lang="html">
	<div v-if="spot != null">
		<div class="places">
			<el-image :src="''" fit="contain" :alt="spot.address">
				<div slot="placeholder" class="image-slot">
					Loading<span class="dot">...</span>
				</div>
				<div slot="error" class="image-slot">
					<i class="el-icon-picture-outline"></i>
				</div>
			</el-image>
		</div>
		<div class="profiles-list-top" v-if="spot.officeClass.isForeign === true">		
			<el-button class="cta" type="primary" @click="mailto"><i class="el-icon-message cta-button-icon"></i>{{ $t('mailCTA') }}</el-button>
			<el-divider></el-divider>
		</div>
		<div class="profiles-list-top" v-else>
			<el-button class="cta" type="primary" @click="cta"><i class="el-icon-printer cta-button-icon"></i>{{ $t('printCTA') }}</el-button>
			<el-divider></el-divider>
		</div>
	</div>
</template>
<script>
export default {
	name: "ProfilesCTA",
	props: {
		spot: Object,
		cta:  Function,
		spot: Object
	},
	data: () => ({
	}),
	methods: {
		mailto: function () {
			window.location.href = `mailto:${this.spot.email}`;
		}
	}
}
</script>
<style lang="scss" scoped>
.profiles-list-top {
	display: flex;           
    flex-direction: column;  
    justify-content: center; 
    align-items: center;  
	width:100%;
}
.cta {
	flex:1;
	width:80%;
	font-weight:bold;
	font-size:1.5em;
	line-height:0.75em;
	display:block;
	margin-bottom:1em;
}
.cta-button-icon {
	margin-right:.5em;
	font-weight:normal;
}
.places {
	min-height:150px;
	display:flex;
	flex-direction: column;  
    justify-content: center; 
    align-items: center;
	margin-bottom: .5em;
	.image-slot {
		font-size:5em;
		flex:1;
	}
}
</style>